class DownloadService {
    downloadFile(filename, url) {
        const a = document.createElement("a");
        a.style.display = "none";
        if (typeof a.download === "string") {
            a.download = filename;
            a.href = url;
            document.body.appendChild(a); // Firefox requires the link to be in the body
            a.click();
            // document.body.removeChild(a); //remove the link when done
            setTimeout(() => {
                document.body.removeChild(a);
            }, 100);
        }
    }
    downloadText(filename, text) {
        this.downloadFile(filename, "data:text/plain;charset=utf-8," + encodeURIComponent(text));
    }
}
export const downloadService = new DownloadService();
